import { IonAccordion } from '@ionic/react';
import { IonicButton } from 'ionic-ui';
import React, { ComponentProps } from 'react';
import { Controller } from 'react-hook-form';
import FileDropBox from '../../../../../../components/ui/FileDropBox/FileDropBox';
import AccordionHeader from '../../../../../../components/Dashboard/getting-started/accordion/AccordionHeader';
import useProfileImageUploadService from '../../../../../../services/userProfile/hooks/useProfileImageUploadService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/store';
import { cropperAspectRatios } from '../../../../../../Constants/imageAspectRatios';
type Props = ComponentProps<typeof IonAccordion>;
export default function UserProfilePictureAccordion({ ...res }: Props) {
  const { signedAccessToken: authToken } = useSelector(
    (state: RootState) => state.userSession
  );
  const existingProfileImage = useSelector(
    (state: RootState) => state.userProfile?.extended_user?.profile_image
  );
  const {
    formMethod: {
      control,
      formState: { isDirty },
    },
    handleFormSubmission,
  } = useProfileImageUploadService({ authToken });
  return (
    <IonAccordion value="Store-brand" {...res}>
      <AccordionHeader>Profile image</AccordionHeader>
      <div
        slot="content"
        className="flex flex-col p-4 gap-4 bg-background dark:bg-background-accent"
      >
        <Controller
          control={control}
          name="store_logo"
          render={({ field, fieldState }) => (
            <div>
              <label className="medium-emphasis-text mb-1 block text-sm">
                Upload Profile Picture
              </label>
              <FileDropBox
                {...field}
                value={field.value}
                onChange={field.onChange}
                allowCropping={true}
                allowPreview
                existingPreviewUrl={existingProfileImage ?? undefined}
                acceptedTypes={{ 'image/jpeg': ['.jpeg', '.png'] }}
                maxFiles={1}
                cropperAspectRatio={cropperAspectRatios.profile_image}
                errorMessage={fieldState.error?.message}
              />
            </div>
          )}
        />

        <div className="py-4">
          <IonicButton
            type="button"
            onClick={handleFormSubmission}
            disabled={!isDirty}
            className="w-full rounded-sm"
          >
            Save
          </IonicButton>
        </div>
      </div>
    </IonAccordion>
  );
}
